module.exports = __webpack_public_path__ + "static/media/perfect-gold_00011.491b94e4.png";